import { Directive } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';

import { UaService } from '@ecm/consumer';
import { RouterService } from '@ecm/router';

import { AbstractComponent } from './abstract.component';

@Directive()
export abstract class AbstractParentComponent extends AbstractComponent {
    private readonly oneIRedirectKey: string = 'no_redirect';

    /**
     * One i query param, override isOne()
     */
    protected oneQueryParam: boolean;

    public constructor(
        protected uaService: UaService,
        protected routerService: RouterService,
        protected route: ActivatedRoute,
    ) {
        super(uaService, routerService);
        this.route.queryParams.subscribe((params: Params) => {
            this.oneQueryParam = params[this.oneIRedirectKey] === 'true';
        });
    }
}
